import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { StatusBadge } from "@/components/shared/StatusBadge";
import { useCollection } from "@/hooks/useCollection";
import { inr, text, fmtTs, toDate } from "@/lib/format";

// Read-only: wallet_holds (amount held at checkout) and wallet_payments (orders paid fully from wallet).
export const WalletLedgerTab = ({ coll, userBy }) => {
  const rows = [...useCollection(coll)].sort((a, b) => (toDate(b.created_at)?.getTime() || 0) - (toDate(a.created_at)?.getTime() || 0));
  const holds = coll === "wallet_holds";
  const name = (id) => { const u = userBy[id] || {}; return u.name || u.full_name || id; };
  return (
    <Card>
      <div className="overflow-x-auto"><Table>
        <TableHeader><TableRow><TableHead>When</TableHead><TableHead>Customer</TableHead><TableHead>For</TableHead><TableHead>{holds ? "Held" : "Wallet used"}</TableHead><TableHead>Bill</TableHead><TableHead>Reference</TableHead><TableHead>{holds ? "Settled" : "Paid"}</TableHead><TableHead>Status</TableHead></TableRow></TableHeader>
        <TableBody>
          {rows.map((r) => (
            <TableRow key={r.id} data-testid={`${coll}-row-${r.id}`}>
              <TableCell className="text-xs text-muted-foreground">{fmtTs(r.created_at)}</TableCell>
              <TableCell className="text-sm">{text(name(r.customer_id || r.uid))}</TableCell>
              <TableCell className="text-sm text-muted-foreground">{text(r.purpose)}</TableCell>
              <TableCell className="font-mono">{inr(holds ? r.amount : r.wallet_used)}</TableCell>
              <TableCell className="font-mono text-sm">{inr(r.bill_amount ?? r.bill_total)}</TableCell>
              <TableCell className="font-mono text-[10px] text-muted-foreground">{text(r.ref_id || r.request_id)}</TableCell>
              <TableCell className="text-xs text-muted-foreground">{fmtTs(r.settled_at || r.paid_at)}</TableCell>
              <TableCell><StatusBadge status={r.status} /></TableCell>
            </TableRow>
          ))}
          {rows.length === 0 && <TableRow><TableCell colSpan={8} className="text-center py-10 text-muted-foreground">Nothing yet.</TableCell></TableRow>}
        </TableBody>
      </Table></div>
    </Card>
  );
};
